export const mobileFormatText = 'Numărul de telefon nu este valid.';

export const validateMobile = (mobile) => {
    // Romanian mobile number regex: 10 digits, starts with '07'
    const romanianMobileRegex = /^07\d{8}$/;
    return romanianMobileRegex.test(mobile);
};
